import simbApi from ".";
import { OFFER_ACCEPT, OFFER_DISMISS, OFFER_STATUS } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export type OfferState = "eligible" | "shown" | "accepted" | "grant_failed" | "expired";

export interface OfferStatusResponse {
  showOffer: boolean;
  state: OfferState | null;
  validUntil: string | null;
  reason?: string;
}

export interface OfferAcceptResponse {
  accepted: boolean;
  state: OfferState | null;
  validUntil: string | null;
  reason?: string;
}

const postOffer = async <T>(endpoint: string, access_token: string): Promise<T> => {
  try {
    const response = await simbApi.post(
      endpoint,
      {},
      { headers: { Authorization: `Bearer ${access_token}` } },
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.message || "Offer request failed");
    }

    return response?.data as T;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};

/** Whether to show the first-month-free offer. The backend decides eligibility and cohort. */
export const fetchOfferStatus = (access_token: string) =>
  postOffer<OfferStatusResponse>(OFFER_STATUS, access_token);

/** Grants the 100% one-month discount on monday. `accepted` can be false without an error. */
export const acceptOffer = (access_token: string) =>
  postOffer<OfferAcceptResponse>(OFFER_ACCEPT, access_token);

export const dismissOffer = (access_token: string) =>
  postOffer<OfferStatusResponse>(OFFER_DISMISS, access_token);
